import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";

import {loadingMessage} from "@Xpresso/loaders/loading-message";

import {Layout} from "../../../../layout/layout";

export const EmulateAgentOfOrder = ({item, next}) => cs(
    consumeContext("session"),
    ["emulateAgentOfOrder", ({session}, next) => !session.loading && next(async ({branchId, agentId}) => {
        await session.applyEmulation({
            branchId,
            ... (agentId === "Branch Order") ? {
                isBranchOrder: true,
            } : {
                agentId,
            },
        });
        return true;
    })],
    ["emulation", ({emulateAgentOfOrder}, next) => Load({
        fetch: () => emulateAgentOfOrder({branchId: item.idBranch, agentId: item.idAgent}),
        next,
    })],
    ({emulation}) => !emulation ? (
        <Layout className="customize-layout-95r" active={"product-options"}>
            <div className="product-options-step-6rz">
                {loadingMessage({message:"Loading Order...",progress:40})}
            </div>
        </Layout>
    ) : (
        next(emulation)
    )
);
